module.exports = __webpack_public_path__ + "static/media/triangle-fill-down.968904c3.svg";